import { combineReducers } from 'redux';

import interventionId from './interventionId';
import model from './model';
import ready from './ready';
import sending from './sending';
import selfServiceType from './type';
import visible from './visible';

/**
 * @typedef {{
 *   ready: boolean,
 *   visible: boolean,
 *   interventionId: string,
 *   model: import('modules/selfServices/types').SelfService,
 *   type: import('modules/selfServices/types').SelfServiceTypeEnum,
 *   sending: boolean,
 * }} SelfServiceSendWizardReducer
 */

export default combineReducers({
  model,
  ready,
  visible,
  sending,
  interventionId,
  type: selfServiceType,
});
